module.exports = __webpack_public_path__ + "static/media/Voranmeldung Krippe.ad281878.pdf";